import React from 'react';
import { Tabs } from 'antd';

import { Page } from '../../../../../shared/ui/Page';
import { items, messages } from '../utils/options';

export const FeedPage = () => {
    return (
        <Page isBackButton title={messages.pageTitle}>
            <Tabs defaultActiveKey='1' items={items} />
        </Page>
    );
};
